import { UploadDocumentsState } from '@store/uploadDocuments/uploadDocuments.state';

export type IntegrationsState = UploadDocumentsState;

export const INITIAL_INTEGRATIONS_STATE: IntegrationsState = {
  jobs: [],
};
